export default __webpack_public_path__ + "static/media/dropbox-deleted.37c58b23.png";